import { Form } from '@anytag/shared-atoms';
import { floatify } from '@anytag/shared-utils';
import { useUpdateYoutubeChannelShareRate } from '../hooks';
import { Template, TemplateProps } from './template';
import { YoutubeCMSChannelRevenueFormValues } from './types';

export type YoutubeCMSChannelsListProps = TemplateProps;

export const YoutubeCMSChannelsList = (props: YoutubeCMSChannelsListProps) => {
  const { handleSaveChange } = useUpdateYoutubeChannelShareRate();

  return (
    <Form.Provider
      onSubmit={handleSaveChange}
      values={props.data?.reduce<YoutubeCMSChannelRevenueFormValues>(
        (acc, { channelId, shareRate }) => ({
          ...acc,
          [`${channelId}-shareRate`]: typeof shareRate === 'number' ? floatify(shareRate * 100).toString() : ''
        }),
        {}
      )}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submit on Enter key, user needs to click the Save button
        }
      }}
    >
      <Template {...props} />
    </Form.Provider>
  );
};

export * from './types';
